const { InnerBlocks } = wp.blockEditor;

export default function save({ attributes }) {
  const { tabsHeading, margin, variant, containerized } = attributes;

  return (
    <div className={`TabSumicity ${margin} ${variant}`}>
      <div className={`${containerized ? 'Container' : ''}`}>
        <div className="TabSumicity__tabs">
          {tabsHeading.map((heading) => {
            if (!heading.title) return null;

            return (
              <a id={heading.tabId} className={`TabSumicity__tabs--title `}>
                {heading.title}
              </a>
            );
          })}
        </div>
        <InnerBlocks.Content />
      </div>
    </div>
  );
}
